'use strict';

var React = require('react');

var SvgColumnWithTextMajor = function SvgColumnWithTextMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 7v-6h-6.5a1.5 1.5 0 0 0-1.5 1.5v4.5h8zm10-4.5a1.5 1.5 0 0 0-1.5-1.5h-6.5v6h8v-4.5zm-18 6.5h8v2h-8v-2zm18 0h-8v2h8v-2zm-18 4h8v2h-8v-2zm18 0h-8v2h8v-2zm-18 4h4v2h-4v-2zm14 0h-4v2h4v-2z"
  }));
};

exports.SvgColumnWithTextMajor = SvgColumnWithTextMajor;
